import { isHttpStatusError } from '~/shared/lib/isHttpStatusError';

export const doesTraderExist = (_: boolean, error: Error) => {
    return isHttpStatusError(error, 404);
};
